<p>{{'wdywp' | translate | async}}</p>
<div class="col-sm-12" >
    <button type="button" class="primary-btn  mb-1" (click)="printBtn('current')">{{'prntcur' | translate | async}}</button>

    <span class="col-sm-1">OR</span>
    <input [(ngModel)]="config.print" type="number" class="col-sm-2 mb-1 mr-2 ml-4">

    <button type="button" class="primary-btn  mb-1" (click)="printBtn('print_all')">{{'button.Print'| translate | async}} {{config.print}} {{'rec'| translate | async}} </button>
    
</div>
